// extracted by mini-css-extract-plugin
export var outer_container = "MiniHeader-module--outer_container--2I-TC";
export var container = "MiniHeader-module--container--eQSo9";